export class FulfillmentMethodTypeStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const info = JSON.parse(data);
            this.assertValid(info);
            return info;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        const fulfillmentMethodTypes = [
            "Delivery",
            "NoContactDelivery",
            "DineIn",
            "Takeaway",
        ];
        if (typeof data !== "string" ||
            data === null ||
            !fulfillmentMethodTypes.includes(data)) {
            throw new Error("Invalid fulfillment method type data");
        }
    }
}
